export const pagesWithoutPermissions = ['/system-notifications', '/settings']

export const permissionsRedirectUrls = [
    {
        url: '/admins',
        accessPermission: 'edit-admins'
    },
    {
        url: '/permissions',
        accessPermission: 'change-admin-permissions'
    },
    {
        url: '/payments',
        accessPermission: 'watch-payments'
    },
    {
        url: '/client-news',
        accessPermission: 'client-news'
    },
    {
        url: '/add-client-article',
        accessPermission: 'client-news'
    },
    {
        url: '/customers',
        accessPermission: 'client-news'
    },
    {
        url: '/customers/:id',
        accessPermission: 'client-news'
    },
    {
        url: '/unallocated-clients',
        accessPermission: 'watch-unallocated-clients'
    },
    {
        url: '/balance-history',
        accessPermission: 'watch-balance-history'
    },
    {
        url: '/account-balance-history',
        accessPermission: 'watch-account-balance-history'
    },
    {
        url: '/card',
        accessPermission: 'watch-cards'
    },
    {
        url: '/leaders',
        accessPermission: 'watch-leaders'
    },
    {
        url: '/business',
        accessPermission: 'watch-business'
    },
    {
        url: '/payouts',
        accessPermission: 'edit-withdraws'
    },
    {
        url: '/referral',
        accessPermission: 'watch-referrals'
    },
    {
        url: '/roles',
        accessPermission: 'edit-roles'
    },
    {
        url: '/create-account',
        accessPermission: 'create-account'
    },
    {
        url: '/notification',
        accessPermission: 'send-push-notifications'
    },
    {
        url: '/news',
        accessPermission: 'create-news'
    },
    {
        url: '/roles/editor',
        accessPermission: 'edit-roles'
    },
    {
        url: '/extended-reports',
        accessPermission: 'watch-extended-reports'
    },
    {
        url: '/extended-reports/list',
        accessPermission: 'edit-extended-reports'
    },
    {
        url: '/extended-reports/categories',
        accessPermission: 'edit-extended-reports'
    },
    {
        url: '/extended-reports/editor',
        accessPermission: 'edit-extended-reports'
    },
    {
        url: '/extended-reports/editor/:id',
        accessPermission: 'edit-extended-reports'
    },
    {
        url: '/client-refill-history',
        accessPermission: 'watch-client-refill-history'
    },
    {
        url: '/system-logs',
        accessPermission: 'watch-system-logs'
    },
    {
        url: '/roles/editor/:id',
        accessPermission: 'edit-roles'
    },
    {
        url: '/groups',
        accessPermission: 'watch-client-groups'
    },
    {
        url: '/cashback',
        accessPermission: 'watch-cashback-system'
    },
    {
        url: '/cashback/editor',
        accessPermission: 'watch-cashback-system'
    },
    {
        url: '/cashback/editor/:id',
        accessPermission: 'watch-cashback-system'
    },
    {
        url: '/news/editor',
        accessPermission: 'create-news'
    },
    {
        url: '/news/editor/:id',
        accessPermission: 'create-news'
    },
    ...[
        'admin/leader-grouping',
        'admin/business-grouping',
        'admin/day-grouping'
    ].map(path => ({
        url: `/reports/${path}`,
        accessPermission: 'watch-reports'
    }))
]
